/**
 * Selector de dia dentro de la ventana publica.
 *
 * Son **radios nativos** disfrazados de fichas. No es un detalle estetico: un grupo de
 * radios trae gratis la navegacion con flechas, el anuncio "2 de 7" del lector de
 * pantalla y el comportamiento correcto del foco. Reimplementarlo con `<div role="tab">`
 * obligaria a escribir a mano lo que el navegador ya hace bien.
 */

import { fechaCorta, fechaLarga } from '@/publico/dominio/formato';

interface PropiedadesSelectorDeDia {
  readonly dias: readonly string[];
  readonly fechaElegida: string;
  readonly hoy: string;
  readonly alElegir: (fecha: string) => void;
}

export function SelectorDeDia({
  dias,
  fechaElegida,
  hoy,
  alElegir,
}: PropiedadesSelectorDeDia): React.JSX.Element {
  return (
    <fieldset className="fichas">
      <legend className="fichas__titulo">Dia</legend>
      <div className="fichas__lista fichas__lista--dias">
        {dias.map((fecha) => {
          const { diaSemana, diaMes } = fechaCorta(fecha);
          const esHoy = fecha === hoy;

          return (
            <div className="ficha" key={fecha}>
              {/*
                El nombre accesible va en `aria-label` y no repartido en spans: el
                algoritmo de nombre accesible recorta cada hijo y los pega sin separador,
                de modo que "mie" y "12" sonarian "mie12". Asi se anuncia la fecha
                completa, que es lo util al oido.
              */}
              <input
                aria-label={`${esHoy ? 'Hoy, ' : ''}${fechaLarga(fecha)}`}
                checked={fecha === fechaElegida}
                id={`dia-${fecha}`}
                name="dia"
                onChange={() => {
                  alElegir(fecha);
                }}
                type="radio"
                value={fecha}
              />
              <label htmlFor={`dia-${fecha}`}>
                <span className="ficha__principal">{esHoy ? 'Hoy' : diaSemana}</span>
                <span className="ficha__secundario">{diaMes}</span>
              </label>
            </div>
          );
        })}
      </div>
    </fieldset>
  );
}
